import _ from 'lodash';
import React from 'react';
import Dropdown from 'react-dropdown';

import { Telemetry } from '@videoblocks/kafka-rest-client';

import { ContentTypes, ContentTypesWithSnapshots } from './ContentTypes';

import './navSearchDropdown.css';

export default function NavSearchDropdown({
  onChange = _.noop,
  value = '',
  useSnapshots = false,
}: {
  onChange: (value: string) => void;
  value: string;
  useSnapshots?: boolean;
}) {
  const handleChange = (event) => {
    const contentType = event.value;
    onChange(contentType);
    Telemetry.increment(`nav.search.${contentType}`);
  };

  return (
    <div
      className="unifiedNav-searchDropdown"
      data-cy="unifiedNav-searchDropdown"
    >
      <Dropdown
        aria-label="Select Search Type"
        onChange={handleChange}
        options={useSnapshots ? ContentTypesWithSnapshots : ContentTypes}
        placeholder="Select..."
        value={value}
        controlClassName="flex items-center justify-between font-inter font-semibold"
        placeholderClassName="whitespace-nowrap"
      />
    </div>
  );
}
